<template>
  <section class="ai-test">
    <ai-top-menu></ai-top-menu>
    <b-container>
      <b-row>
        <b-col sm="12">
          <label>Mask:</label>
          <b-form-textarea size="sm" v-model="mask"></b-form-textarea>
        </b-col>
        <b-col sm="10">
          <label>Mask variables file:</label>
          <b-form-file
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            v-model="file">
          </b-form-file>
        </b-col>
        <b-col sm="2">
          <label>Ordering:</label>
          <b-form-input size="sm" v-model="ordering"></b-form-input>
        </b-col>
      </b-row>
      <b-button v-if="!isImporting" v-on:click="save" class="mt-3 but-add-task" variant="primary">Save</b-button>
      <section v-if="isImporting" class="mr-sm-5">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        In progress ...
      </section>
    </b-container>
  </section>
</template>
<script>
import {createNamespacedHelpers} from "vuex";
import aiTopMenu from "@/components/ai/components/topMenu.vue";

const {mapGetters, mapActions} = createNamespacedHelpers('ai/test')
export default {
  name: 'AiTestForm',
  components: {aiTopMenu},
  data() {
    return {
      mask: '',
      file: null,
      ordering: '1',
      isImporting: false
    }
  },
  computed: {
  },
  methods: {
    save() {
      if (!this.file) {
        this.$bvModal.msgBoxOk('Поле File обязательно')
        return false;
      }
      if (this.ordering === '') {
        this.$bvModal.msgBoxOk('Поле Ordering обязательно')
        return false;
      }

      let formData = new FormData();

      formData.append('mask', this.mask);
      formData.append('maskFile', this.file);
      formData.append('ordering', this.ordering);

      let th = this;
      this.isImporting = true;
      this.$store.dispatch('SEND_POST', {
        url: '/ai/test',
        parameter: formData,
        th: th,
        getResponse: () => {
          th.isImporting = false;
        },
        getSuccessResponse: (data) => {
            console.log(data);
        },
        showSuccessMessage: true
      });
    },
  }
}
</script>